<template>
  <div>
    <loading
      v-if="isFullScreen"
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      color="#0573ab"
    ></loading>
    <div v-else :class="[`loading`, isSmall ? `loading--spinner--small` : `loading--spinner--medium`]">
      <div class="loading__spinner">
        <svg
          class="loading__spinner__circle"
          xmlns="http://www.w3.org/2000/svg"
          width="100px"
          heigth="100px"
          viewBox="0 0 100 100"
        >
          <circle
            class="loading__spinner__circle__outer"
            cx="50"
            cy="50"
            fill="none"
            stroke="gray"
            stroke-width="10"
            r="40"
          />
          <circle
            class="loading__spinner__circle__inner"
            cx="50"
            cy="50"
            fill="none"
            stroke="black"
            stroke-width="10"
            r="40"
            stroke-dasharray="55 200"
          />
        </svg>
      </div>
      <div v-if="label" class="loading__label">{{ label }}</div>
    </div>
  </div>
</template>

<script>
// Loading component
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Spinner",
  components: {
    Loading,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    isSmall: {
      type: Boolean,
      required: true,
    },
    isFullScreen: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>